/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './highlight.ngfactory';
import * as i2 from '@ng-bootstrap/ng-bootstrap/typeahead/highlight';
import * as i3 from '@angular/common';
import * as i4 from '@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window';
const styles_NgbTypeaheadWindow:any[] = ([] as any[]);
export const RenderType_NgbTypeaheadWindow:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbTypeaheadWindow,data:{}});
function View_NgbTypeaheadWindow_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),1,'ngb-highlight',([] as any[]),(null as any),(null as any),
      (null as any),i1.View_NgbHighlight_0,i1.RenderType_NgbHighlight)),i0.ɵdid(573440,
      (null as any),0,i2.NgbHighlight,([] as any[]),{result:[0,'result'],term:[1,'term']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.formatter(_v.context.result);
    const currVal_1:any = _v.context.term;
    _ck(_v,2,0,currVal_0,currVal_1);
  },(null as any));
}
function View_NgbTypeaheadWindow_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
function View_NgbTypeaheadWindow_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),5,'button',[['class','dropdown-item'],['role','option'],
          ['type','button']],[[8,'id',0],[2,'active',(null as any)]],[[(null as any),
          'mouseenter'],[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>_co.markActive(_v.context.index)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.select(_v.context.$implicit)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_NgbTypeaheadWindow_3)),
      i0.ɵdid(540672,(null as any),0,i3.NgTemplateOutlet,[i0.ViewContainerRef],{ngTemplateOutlet:[0,
          'ngTemplateOutlet'],ngOutletContext:[1,'ngOutletContext']},(null as any)),
      i0.ɵpod({result:0,term:1,formatter:2}),(_l()(),i0.ɵted((null as any),['\n      '])),
      (_l()(),i0.ɵted((null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = (_co.resultTemplate || i0.ɵnov((<any>_v.parent),1));
    const currVal_3:any = _ck(_v,5,0,_v.context.$implicit,_co.term,_co.formatter);
    _ck(_v,4,0,currVal_2,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = ((_co.id + '-') + _v.context.index);
    const currVal_1:any = (_v.context.index === _co.activeIdx);
    _ck(_v,1,0,currVal_0,currVal_1);
  });
}
export function View_NgbTypeaheadWindow_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵand(0,[['rt',
      2]],(null as any),0,(null as any),View_NgbTypeaheadWindow_1)),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NgbTypeaheadWindow_2)),i0.ɵdid(802816,(null as any),0,i3.NgForOf,[i0.ViewContainerRef,
      i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i4.NgbTypeaheadWindow = _v.component;
    const currVal_0:any = _co.results;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_NgbTypeaheadWindow_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-typeahead-window',
      [['class','dropdown-menu'],['role','listbox'],['style','display: block']],[[8,
          'id',0]],(null as any),(null as any),View_NgbTypeaheadWindow_0,RenderType_NgbTypeaheadWindow)),
      i0.ɵdid(114688,(null as any),0,i4.NgbTypeaheadWindow,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).id;
    _ck(_v,0,0,currVal_0);
  });
}
export const NgbTypeaheadWindowNgFactory:i0.ComponentFactory<i4.NgbTypeaheadWindow> = i0.ɵccf('ngb-typeahead-window',
    i4.NgbTypeaheadWindow,View_NgbTypeaheadWindow_Host_0,{id:'id',focusFirst:'focusFirst',
        results:'results',term:'term',formatter:'formatter',resultTemplate:'resultTemplate'},
    {selectEvent:'select',activeChangeEvent:'activeChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvdHlwZWFoZWFkL3R5cGVhaGVhZC13aW5kb3cubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC90eXBlYWhlYWQvdHlwZWFoZWFkLXdpbmRvdy5kLnRzIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC90eXBlYWhlYWQvdHlwZWFoZWFkLXdpbmRvdy5kLnRzLk5nYlR5cGVhaGVhZFdpbmRvdy5odG1sIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC90eXBlYWhlYWQvdHlwZWFoZWFkLXdpbmRvdy5kLnRzLk5nYlR5cGVhaGVhZFdpbmRvd19Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy10ZW1wbGF0ZSAjcnQgbGV0LXJlc3VsdD1cInJlc3VsdFwiIGxldC10ZXJtPVwidGVybVwiIGxldC1mb3JtYXR0ZXI9XCJmb3JtYXR0ZXJcIj5cbiAgICAgIDxuZ2ItaGlnaGxpZ2h0IFtyZXN1bHRdPVwiZm9ybWF0dGVyKHJlc3VsdClcIiBbdGVybV09XCJ0ZXJtXCI+PC9uZ2ItaGlnaGxpZ2h0PlxuICAgIDwvbmctdGVtcGxhdGU+XG4gICAgPG5nLXRlbXBsYXRlIG5nRm9yIFtuZ0Zvck9mXT1cInJlc3VsdHNcIiBsZXQtcmVzdWx0IGxldC1pZHg9XCJpbmRleFwiPlxuICAgICAgPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgY2xhc3M9XCJkcm9wZG93bi1pdGVtXCIgcm9sZT1cIm9wdGlvblwiXG4gICAgICAgIFtpZF09XCJpZCArICctJyArIGlkeFwiXG4gICAgICAgIFtjbGFzcy5hY3RpdmVdPVwiaWR4ID09PSBhY3RpdmVJZHhcIlxuICAgICAgICAobW91c2VlbnRlcik9XCJtYXJrQWN0aXZlKGlkeClcIlxuICAgICAgICAoY2xpY2spPVwic2VsZWN0KHJlc3VsdClcIj5cbiAgICAgICAgICA8bmctdGVtcGxhdGUgW25nVGVtcGxhdGVPdXRsZXRdPVwicmVzdWx0VGVtcGxhdGUgfHwgcnRcIlxuICAgICAgICAgIFtuZ091dGxldENvbnRleHRdPVwie3Jlc3VsdDogcmVzdWx0LCB0ZXJtOiB0ZXJtLCBmb3JtYXR0ZXI6IGZvcm1hdHRlcn1cIj48L25nLXRlbXBsYXRlPlxuICAgICAgPC9idXR0b24+XG4gICAgPC9uZy10ZW1wbGF0ZT5cbiAgIiwiPG5nYi10eXBlYWhlYWQtd2luZG93PjwvbmdiLXR5cGVhaGVhZC13aW5kb3c+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ21GLDZDQUM3RTtNQUFBO01BQUEseUVBQUE7TUFBQTtNQUFBLGVBQTBFO0lBQTNEO0lBQTZCO0lBQTVDLFdBQWUsVUFBNkIsU0FBNUM7Ozs7Ozs7O29CQUVnRSw2Q0FDaEU7TUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1FBR0U7VUFBQTtVQUFBO1FBQUE7UUFDQTtVQUFBO1VBQUE7UUFBQTtRQUpGO01BQUEsZ0NBSTJCO01BQ3ZCO2FBQUE7VUFBQTthQUNBLGdDQUFxRjtNQUNoRjs7SUFGUTtJQUNiO0lBREEsV0FBYSxVQUNiLFNBREE7OztJQUpGO0lBQ0E7SUFGRixXQUNFLFVBQ0EsU0FGRjs7OztvQkFMTiwyQ0FDSTtNQUFBLDhEQUVjO01BQUEsYUFDZDtNQUFBLG1DQUFBO3VDQUFBLHlDQVNjO2FBQUE7O0lBVEs7SUFBbkIsV0FBbUIsU0FBbkI7Ozs7b0JDSko7TUFBQTtVQUFBO2FBQUE7VUFBQTtJQUFBOztJQUFBO0lBQUEsV0FBQSxTQUFBOzs7Ozs7In0=



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.ngfactory.ts